<template>
  <!-- Filters Section -->
  <div>
    <div v-if="filters" class="flex">

      <select
        id="filter"
        v-model="filter"
        class="w-full py-3 text-gray-600 uppercase bg-no-repeat border border-gray-500 appearance-none filter-select-arrow active:normal-case focus:border-gray-500 focus:ring-transparent bg-7"
      > 
        <option
          :value="null"
          selected
          >
          {{ allRecipes }}
        </option>

        <option
          v-for="filter in filters"
          :key="filter.id"
          :value="filter.id"
          v-html="filter.name"
          >
        </option>
      </select>

    </div>
  </div>
  <!-- Close Filters Section -->
</template>

<script>
// Import Getters and Actions from Vuex
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Filters",
  props: {
    allRecipes: ''
  },
  computed: {
    ...mapGetters(['filters']),
    filter: {
      get () {
        return this.$store.state.filter
      },
      set (value) {
        this.$store.commit('setFilter', value)
      }
    }
  },
  methods: {
    ...mapActions(['getRecipeCategories']),
  },
  mounted () {
    this.getRecipeCategories();
  }
};
</script>
